import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from '../components/login/LoginForm';
import { InputField } from '../components/login/InputField';
import { LoginButton } from '../components/login/LoginButton';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [emailTouched, setEmailTouched] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setEmailTouched(true);
    setPasswordTouched(true);
    setError(null);
    if (!email || !password) {
      setError('E-mail e senha são obrigatórios.');
      return;
    }
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error || 'Erro ao autenticar.');
    }
  };

  const emailError = emailTouched && !email;
  const passwordError = passwordTouched && !password;

  return (
    <LoginForm onSubmit={handleSubmit}>
      <div style={{ marginBottom: 24 }}>
        <img src="assets/logo/Marca d_agua - Aviva-12.png" alt="Logo" style={{ width: 70, height: 70 }} />
      </div>
      <h2 style={{ fontWeight: 700, fontSize: 24, margin: 0, marginBottom: 4, color: '#234C7C' }}>Bem-vindo à Gestão</h2>
      <div style={{ color: '#6CA0DC', fontSize: 15, marginBottom: 28 }}>Acesse sua conta para continuar</div>
      {error && (
        <div style={{ color: '#F44336', background: '#FFF0F0', borderRadius: 6, padding: '8px 12px', marginBottom: 16, width: '100%', textAlign: 'center', fontSize: 15, maxWidth: 300 }}>
          {typeof error === 'string' ? error : 'Erro ao autenticar.'}
        </div>
      )}

      <InputField
        label="E-mail"
        type="email"
        value={email}
        onChange={setEmail}
        onBlur={() => setEmailTouched(true)}
        error={emailError}
        errorMessage="E-mail é obrigatório"
        placeholder="Digite seu e-mail"
        icon={
          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <rect x="2" y="7" width="20" height="14" rx="2" />
            <path d="M2 7l10 7 10-7" />
          </svg>
        }
        disabled={loading}
      />

      <InputField
        label="Senha"
        type={showPassword ? 'text' : 'password'}
        value={password}
        onChange={setPassword}
        onBlur={() => setPasswordTouched(true)}
        error={passwordError}
        errorMessage="Senha é obrigatória"
        placeholder="Digite sua senha"
        icon={
          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <rect x="3" y="11" width="18" height="8" rx="4" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        }
        disabled={loading}
        showPasswordToggle
        onTogglePassword={() => setShowPassword(s => !s)}
        showPassword={showPassword}
      />



      <LoginButton loading={loading} />
    </LoginForm>
  );
};

export default Login;